import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import SectionOptional from '../../../components/layout/SectionOptional';
import Callout from '../../../helpContext/Callout';
import { ModeSelectorDropdown } from '../../../simulation/sidebar/MenuModeSelector';
import {
  simulationIsEditable,
  simulationManualLock,
} from '../../../simulation/store/simulation.state';

export const SettingsSimulation: React.FC = () => {
  const { t } = useTranslation('simulation');
  const [isSimulationManuallyLocked, setIsManuallyLocked] =
    useRecoilState(simulationManualLock);
  const isSimulationEditable = useRecoilValue(simulationIsEditable);

  return (
    <div className="flex flex-col p-4">
      {/* <InputGroupList className="p-4"> */}
      <ModeSelectorDropdown />
      {/* </InputGroupList> */}

      {/* <InputGroupList className="space-y-2"> */}
      <Callout type="admin">
        <div>
          {isSimulationManuallyLocked
            ? t`This simulation is locked for editing`
            : isSimulationEditable
              ? t`This simulation is open for editing`
              : t`This simulation is locked`}
        </div>

        <SectionOptional
          id={'simulation-lock'}
          title={t`Simulation Lock`}
          value={isSimulationManuallyLocked}
          onChange={setIsManuallyLocked}
          // isDisabled={isEditable}
        ></SectionOptional>
      </Callout>
      {/* </InputGroupList> */}
    </div>
  );
};
